module.exports = __webpack_public_path__ + "img/0Q3A2626_L_BlackMatted_MockedUp.447146bb.jpg";